import React from 'react';
import EventsSection from '../components/home/EventsSection';

const Events = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>Events & Meetups</h1>
          <p>Join us for networking and business opportunities</p>
        </div>
      </section>
      <EventsSection />
    </>
  );
};

export default Events;

